export const SkeletonCard = () => (
  <div className="animate-pulse mx-auto w-full max-w-64 p-4">
    <div className="p-2">
      <div className="w-full h-48 bg-gray/50"></div>
    </div>
    <div className="mt-4 mx-2 h-4 bg-gray/50"></div>
    <div className="mt-2 h-4 mx-2 bg-gray/50 w-1/2"></div>
  </div>
);
